import { mfLogoBaseUrl } from '../../env'
import { getAppOStype } from '../utils'

/**
 * Builds a full CDN URL for a static MF asset path using `VITE_MF_LOGO_BASE_URL`
 * from `.env.local` (e.g. `VITE_MF_LOGO_BASE_URL=https://cdn.powerup.money/assets`).
 *
 * `assetPath` is appended to the base as-is — typically `/images/...` from API or config.
 * Already-absolute `http(s)` URLs are returned unchanged.
 */
export function getMfCdnAssetUrl(assetPath: string): string {
  const path = assetPath?.trim() ?? ''
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) return path
  return `${mfLogoBaseUrl}${path}`
}

export function isAndroidApp(): boolean {
  return getAppOStype()?.toLowerCase() === 'android'
}

/**
 * Resolves a UPI app logo from static config (`upiAppConfig`).
 * Payment logos live on the CDN (not in the webview bundle), so paths are always
 * prefixed with `VITE_MF_LOGO_BASE_URL` on every platform.
 */
export function resolveUpiAppConfigLogoUrl(logoPath: string): string {
  const path = logoPath?.trim() ?? ''
  if (!path) return ''
  return getMfCdnAssetUrl(path)
}
